module.exports = __webpack_public_path__ + "static/cloud-32556161621cd1051994d8911e544d0f.svg";